import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CoatingsComponent } from './coatings/coatings.component';
import { LensPrescriptionComponent } from './lens-prescription/lens-prescription.component';
import { LensOptionsComponent } from './lens-options/lens-options.component';
import { LensSelectionComponent } from './lens-selection.component';
import { SingleVisionComponent } from './single-vision/single-vision.component';
import { BifocalProgressiveComponent } from './bifocal-progressive/bifocal-progressive.component';
import { LensAccessoriesComponent } from './lens-accessories/lens-accessories.component';
import { ScratchComponent } from './scratch/scratch.component';
import { TintsComponent } from './tints/tints.component';
import { LensReadersComponent } from './lens-readers/lens-readers.component';
import { NonPrescriptionComponent } from './non-prescription/non-prescription.component';

const routes: Routes = [
    {
      path: '',
      data: {
        title: 'Lens Selection'
      },
      children: [
        {
          path: '',
          component: LensSelectionComponent,
          data: { title: 'Eyewear Builder'}
        },
        {
          path: 'accessories',
          children: [
            {
                path: '',
                component: LensAccessoriesComponent,
                data: { title: 'Lens Accessories'}
            }        
          ]    
        },
        {
          path: 'readers',
          children: [
            {
                path: '',
                component: LensReadersComponent,
                data: { title: 'Readers'}
            }        
          ]    
        },
        {
          path: 'non-prescription',
          children: [
            {
                path: '',
                component: NonPrescriptionComponent,
                data: { title: 'Non-Prescription'}
            }        
          ]    
        },
        {
          path: 'prescription',
          children: [
            {
                path: '',
                component: LensPrescriptionComponent,
                data: { title: 'Lens Selection'}
            },
            {
                path: 'single-vision',
                component: SingleVisionComponent,
                data: { title: 'Single Vision'}
            },
            {
              path: 'bifocal-progressive',
              component: BifocalProgressiveComponent,
              data: { title: 'Bifocal Progressive'}
            }    
          ]    
        },
        {
          path: 'options',
          children: [
            {
                path: '',
                component: LensOptionsComponent,
                data: { title: 'Lens Options'}
            },
            {
                path: 'coatings',
                component: CoatingsComponent,
                data: { title: 'Coatings'}
            },
            {
              path: 'scratch',
              component: ScratchComponent,
              data: { title: 'Scratch'}
            },
            {
              path: 'tints',
              component: TintsComponent,
              data: { title: 'Tints'}
            }
          ]    
        }        
      ]
    }        
  ];

  
  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class LensSelectionRoutingModule { }
  